import {
  B2B,
  Cart,
  Facility,
  Health,
  Hotel,
  Learning,
  Maintenance,
  Manufacturing,
  Nonprofit,
  Shipyard,
  Startup,
  Yacht,
} from '@/components/SvgIcons/Industries';
import { Industry } from '@/types/industry.type';

export const industries: Industry[] = [
  {
    id: 'yachting',
    titleKey: 'industrySolutions.industries.yachting',
    icon: Yacht,
    color: 'blue',
  },
  {
    id: 'ecommerce',
    titleKey: 'industrySolutions.industries.ecommerce',
    icon: Cart,
    color: 'pink',
  },
  {
    id: 'marine',
    titleKey: 'industrySolutions.industries.marine',
    icon: Shipyard,
    color: 'green',
  },
  {
    id: 'tourism',
    titleKey: 'industrySolutions.industries.tourism',
    icon: Hotel,
    color: 'orange',
  },
  {
    id: 'maintenance',
    titleKey: 'industrySolutions.industries.maintenance',
    icon: Maintenance,
    color: 'green',
  },
  {
    id: 'manufacturing',
    titleKey: 'industrySolutions.industries.manufacturing',
    icon: Manufacturing,
    color: 'orange',
  },
  {
    id: 'facilities',
    titleKey: 'industrySolutions.industries.facilities',
    icon: Facility,
    color: 'pink',
  },
  {
    id: 'startups',
    titleKey: 'industrySolutions.industries.startups',
    icon: Startup,
    color: 'blue',
  },
  {
    id: 'b2b',
    titleKey: 'industrySolutions.industries.b2b',
    icon: B2B,
    color: 'pink',
  },
  {
    id: 'education',
    titleKey: 'industrySolutions.industries.education',
    icon: Learning,
    color: 'green',
  },
  {
    id: 'health',
    titleKey: 'industrySolutions.industries.health',
    icon: Health,
    color: 'blue',
  },
  {
    id: 'nonprofits',
    titleKey: 'industrySolutions.industries.nonprofits',
    icon: Nonprofit,
    color: 'orange',
  },
];
